export const parser = (value: string | undefined) => {
  if (typeof value === 'string') return value.replace(/\$\s?|(,*)/g, '')
  return ''
}

export const formatter = (value: number | string | undefined) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const phoneNumberRegex: RegExp = new RegExp(/^(\([1-9][0-9]{2}\))\s[0-9]{3}-[0-9]{4}$/)

export const phoneNumberRegexWithUnderscore: RegExp = new RegExp(/^(\([0-9]{3}\))\s[0-9]{3}-[0-9]{2}(__|\d_|\d\d)?$/)

export const zipNumberRegex: RegExp = new RegExp(/^[0-9]{5}$/)

export const identificationNumberRegex: RegExp = new RegExp(/^[0-9]{2}-[0-9]{7}$/)

export const formatOnlyChars: RegExp = new RegExp(/^[a-zA-Z ]+$/)
